import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/site/Landing';

Vue.use(Router);

export default new Router({
   routes: [
      {
         path: '/',
         name: 'Landing',
         component: Landing
      },
      {
         path: '*', 
         redirect: '/'
      }
   ],
   mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js